import getApiClient from '@/plugins/api-client'

export default {
    loadPost: function(id) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`posts/${id}`)
            .then(result => {
                self.post = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    setPostStatus: function(status) {
        this.post.status = parseInt(status)
    },
    setPostRoles: function(roles) {
        this.post.roles = [roles]
    },
    savePost: function() {
        const self = this,
            postId = self.post.id

        self.post.roles = self.post.roles.filter(item => {
            return item
        })

        if (postId) {
            return self.updatePost()
        }

        return self.createPost()
    },
    createPost: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.post('posts', self.post)
            .then(result => {
                self.post = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },
    updatePost: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.patch(`posts/${self.post.id}`, self.post, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.post = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
